var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"context-menu-item",on:{"click":_vm.onClick}},[_c('span',{staticClass:"context-menu-icon-wrapper"},[_vm._t("context-menu-item-icon")],2),_c('span',{staticClass:"context-menu-item-text aisea-text-14-400-black"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }